import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import store from "./redux/store";
import Layout from "./components/Layout";
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

import "styles/main.scss";
import Maintenance from "components/Maintanence";
import { getLocalStorageValue } from "config/helper";
import { initSentry } from "config/sentry";
import { setupGlobalErrorHandlers } from "utils/globalErrorHandler";

initSentry();

const maintanenceError = getLocalStorageValue("maintanenceError");

setupGlobalErrorHandlers();
const queryClient = new QueryClient();

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <BrowserRouter>
        <QueryClientProvider client={queryClient}>
          {maintanenceError == "502" ? <Maintenance /> : <Layout />}
        </QueryClientProvider>
      </BrowserRouter>
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
)
